import AppPage from '@pages/appPage';
import { hydrateWithEmotion } from '@utils/ssr/clientRenderer';
import ReactOnRails from 'react-on-rails';

ReactOnRails.register({
  AppPage: hydrateWithEmotion(AppPage),
});
